<template>
	<Layout :loading="loading" :pageTitle="title" :backlink="`/memberships`">
		<template #cta>
			<div>
				<router-link tag="a" :to="`/memberships/${$route.params.id}/update`" class="btn btn-secondary">
					Editar
				</router-link>

				<b-dropdown no-caret right class="dropdown-dots" v-if="item">
					<template v-slot:button-content><i class="icon icon-dot-3"></i></template>
					<b-dropdown-item @click="deletePrompt(item)" class="delete-item">
						<i class="icon icon-trashcan"></i> Eliminar
					</b-dropdown-item>
				</b-dropdown>
			</div>
		</template>

		<Loader :loading="loading" type="inline" />

		<template #head>
			<div v-if="item">
				<div class="event-head pb-4">
					<div
						class="image"
						v-if="item && item.image"
						:style="`background-image: url(${item.image.url})`"
					></div>
					<div class="data flex-grow-1">
						<h1>{{ item.name }}</h1>
						<div class="description">
							Disponible hasta: {{ item.validAt | moment("ddd DD [de] MMMM YYYY, HH:mm") }}
							<br />
							<strong>{{ item.currencySymbol }} {{ item.price | toCurrency }}</strong>
						</div>
					</div>
				</div>

				<ul class="nav nav-tabs">
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/memberships/${item.id}`"
							:class="{ active: !tab || tab == '' }"
							class="nav-link"
							>Dashboard</router-link
						>
					</li>
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/memberships/${item.id}/sells`"
							:class="{ active: tab == 'sells' }"
							class="nav-link"
							>Vendidas</router-link
						>
					</li>
					<li class="nav-item">
						<router-link
							tag="a"
							:to="`/memberships/${item.id}/access`"
							:class="{ active: tab == 'access' }"
							class="nav-link"
							>Accesos</router-link
						>
					</li>
				</ul>
			</div>
		</template>

		<div class="main-container container" v-if="!loading && item">
			<div class="row row-xs">
				<div class="col-12  py-3">
					<div v-if="!tab">
						<div class="px-2">
							<MembershipDashboard :id="item.id" />
						</div>
					</div>

					<div v-if="tab == 'sells'">
						<div class="px-2">
							<div class="d-flex justify-content-between align-items-center">
								<h5 class="mb-0">Membresías vendidas</h5>
								<div class="filters-box justify-content-between">
									<div class="filter">
										<div class="filter-input">
											<i class="icon icon-search"></i>
											<input
												type="text"
												class="form-control"
												placeholder="Buscar en membresías"
												v-model="filters.search"
												@keyup.enter="updateFilters($event)"
											/>
											<div
												class="btn btn-light btn-clear-filter"
												v-if="filters.search"
												@click="
													filters.search = null
													updateFilters()
												"
											>
												<i class="icon icon-close"></i>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="card">
								<div class="coard-body">
									<MembershipSellsTable :membershipTypeId="item.id" />
								</div>
							</div>
						</div>
					</div>

					<div v-if="tab == 'access'">
						<div class="px-2">
							<div class="d-flex justify-content-between align-items-center">
								<h5 class="mb-0">Registro de accesos</h5>
								<div class="filters-box justify-content-between">
									<div class="filter">
										<div class="filter-input">
											<i class="icon icon-search"></i>
											<input
												type="text"
												class="form-control"
												placeholder="Buscar en accesos"
												v-model="filters.search"
												@keyup.enter="updateFilters($event)"
											/>
											<div
												class="btn btn-light btn-clear-filter"
												v-if="filters.search"
												@click="
													filters.search = null
													updateFilters()
												"
											>
												<i class="icon icon-close"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card">
								<div class="coard-body">
									<MembershipAccessTable :membershipTypeId="item.id" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import gql from "graphql-tag"
import MembershipDashboard from "./MembershipDashboard"
import MembershipSellsTable from "./MembershipSellsTable"
import MembershipAccessTable from "./MembershipAccessTable"

export default {
	name: "MembershipDetail",
	components: {
		MembershipDashboard,
		MembershipSellsTable,
		MembershipAccessTable
	},
	data() {
		return {
			item: null,
			title: "Detalle de la membresía",
			loading: true,
			tab: null
		}
	},
	async beforeMount() {
		this.filters = this.getValidUrlParams()
		if (!this.$route.params.id) this.$router.push(-1)
		await this.load()
		this.tab = this.$route.params.tab || null
	},
	methods: {
		async load() {
			this.loading = true
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							membershipType(id: $id) {
								id
								name
								validAt
								description
								currencySymbol
								price
								sold
								limit
								image {
									id
									type
									filename
									url
									urlThumb
								}
							}
						}
					`,
					variables: { id: this.$route.params.id },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.loading = false
					this.item = data.membershipType
					return data.event
				})
				.catch(() => {})
		},

		deletePrompt() {
			this.$dialog
				.confirm(
					{
						title: "Eliminar evento",
						body: `¿Está seguro que desea eliminar el evento "<strong>${this.item.name}"</strong>?`
					},
					{
						okText: "Eliminar",
						customClass: "delete-prompt"
					}
				)
				.then(() => {
					this.delete()
				})
		},

		delete() {
			this.loading = true
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!) {
							eventDelete(id: $id) {
								id
							}
						}
					`,
					variables: {
						id: this.item.id
					}
				})
				.then(() => {
					this.$toast.success("Evento eliminado correctamente")
					this.$router.push("/events")
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.event-head {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	padding: 0px;

	.image {
		width: 100px;
		height: 100px;
		border-radius: 8px;
		background-color: #eee;
		background-size: cover;
		background-position: center;
		margin-right: 1rem;
	}

	.data {
		padding: 0x 16px;

		.badge {
			border-radius: 3px;
			display: inline-block;
			padding: 1px 8px;
			font-weight: 500;
			// background-color: rgb(255, 241, 233);
			// color: rgb(212, 48, 2);
			font-size: 12px;
			line-height: 20px;
			margin-bottom: 4px;
		}

		h1 {
			margin-bottom: 0px;
			font-weight: 600;
			font-size: 24px;
			line-height: 32px;
		}
		.description {
			strong {
				font-weight: 500;
			}
		}
	}
}

.main-image {
	width: 100%;
	padding-bottom: 40%;
	border-radius: 8px;
	background-size: cover;
	background-position: center;
	margin-bottom: 12px;
}

.icons i {
	color: #888;
}
</style>
